import {Injectable} from '@angular/core';

@Injectable()
export class SchemasService {
    public currentBaseName: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/schemas/schemas.service.ts